import { Subscription } from 'rxjs';
import { IDashboardData } from '@models/Dashboard';
import { IChartSelectEvent } from '@models/Dashboard';
import { ChartJSService } from '@services/chartjs.service';
import { AfterContentInit, Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { AsyncUtils } from '@utils/AsyncUtils';
import { outputAst } from '@angular/compiler';

@Component({
	selector: 'bar-chart',
	templateUrl: './bar-chart.component.html',
	styleUrls: ['./bar-chart.component.scss'],
})
export class BarChartComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	@Input('height') Height: string = "400";

	@ViewChild('canvasChart') canvasChart: ElementRef<HTMLCanvasElement>;

	@Input() data: IDashboardData;

	/** Emitido ao clicar numa barra (drill-in). */
	@Output() select: EventEmitter<IChartSelectEvent> = new EventEmitter<IChartSelectEvent>();

	private chart: any;

	/** Conteúdo do último `data` desenhado — usado para não redesenhar o que não mudou. */
	private lastSignature: string = null;

	constructor(private ChartJSService: ChartJSService) { }

	ngOnInit() {
		// console.log(this.Height);


		// this.normalizeData();
	}

	ngOnDestroy(): void {

		if (this.chart)
			this.chart.destroy();

		// console.log("destroy ->", this.chart);

	}

	ngAfterViewInit(): void {

		// Adiado um tick: garante que o container já tem tamanho quando o Chart.js mede
		// (senão, no primeiro render após revelar o segmento, o gráfico fica em branco).
		setTimeout(() => { if (this.canvasChart?.nativeElement) this.normalizeData(); });
	}

	/**
	 * O Chart.js não observa o array de dados: quando o `[data]` é substituído (ex.: nova
	 * pesquisa por datas) é preciso destruir e recriar o gráfico, senão o canvas mantém
	 * a série anterior. A primeira mudança é ignorada — quem cria é o ngAfterViewInit.
	 */
	ngOnChanges(changes: SimpleChanges): void {

		if (!changes['data'] || changes['data'].firstChange) return;
		if (!this.canvasChart?.nativeElement) return;

		// Compara o CONTEÚDO, não a referência: há bindings que criam um objeto novo a cada
		// ciclo de deteção de mudanças (ex.: [data]="{IdType:…, labels:[], datasets:[…]}" inline),
		// e isso não deve provocar um redesenho por ciclo.
		const signature = this.buildSignature(this.data);
		if (signature !== null && signature === this.lastSignature) return;

		this.rebuild();
	}

	/** Assinatura do conteúdo desenhado (eixo + séries). `null` = não comparável → redesenha. */
	private buildSignature(data: IDashboardData): string {

		try {
			return JSON.stringify({
				labels: data?.labels ?? [],
				datasets: (data?.datasets ?? []).map((s: any) => [s?.label, s?.data]),
			});
		}
		catch { return null; }
	}

	/** Destrói o gráfico atual (se existir) e volta a desenhá-lo com o `data` corrente. */
	private rebuild() {

		if (this.chart) {
			this.chart.destroy();
			this.chart = null;
		}

		this.normalizeData();
	}


	private async normalizeData(data: any = this.data) {
		
		// test 2 or more datasets
		// const tmp = [...data?.datasets, ...data?.datasets];
		
		this.lastSignature = this.buildSignature(data);

		this.chart = await this.ChartJSService.GetBarChart(this.canvasChart.nativeElement, data?.labels, data?.datasets);

		this.attachClickHandler();
	}

	/** Liga o clique no canvas ao output `select` (barra mais próxima do cursor). */
	private attachClickHandler() {

		if (!this.chart || !this.canvasChart?.nativeElement) return;

		this.canvasChart.nativeElement.onclick = (evt: MouseEvent) => {

			const points = this.chart.getElementsAtEventForMode(evt, 'nearest', { intersect: true }, true);
			if (!points?.length) return;

			const { datasetIndex, index } = points[0];
			const ds = this.chart.data.datasets[datasetIndex];

			this.select.emit({
				label: this.chart.data.labels?.[index],
				value: ds?.data?.[index],
				datasetLabel: ds?.label,
				index,
				datasetIndex,
			});
		};
	}

}
